module.exports = __webpack_public_path__ + "img/GAME_PICTURELOTUS2.507a44da.jpg";